    import O1HD, {modules} from "../engines/gameEngine";
import {REWARD_TYPE} from "../engines/services/userContent/userInterface";
import gameConfig from "../engines/configs/gameConfig";
import PageBase from "../engines/modules/uiModule/PageBase";
import { IPagePramsBase } from "../engines/modules/uiModule/UIPrams";
import utilsModel from "../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class InfinityPower extends PageBase {

    @property(cc.Node)
    detail: cc.Node = null;

    @property(cc.Label)
    looktimeLabel: cc.Label = null;

    @property(cc.Label)
    lbMessageExplain: cc.Label = null;

    @property(cc.Prefab)
    RewardView: cc.Prefab = null;

    @property(cc.Node)
    Reward: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:
    private readonly InfinityModel: string = 'user-is-infinity';

    private static lookedTimes: number = 0

    // onLoad() {
    //     this.UpdateLookLabel()
    // }

    // protected start(): void {
    //     // modules().uiControlModule.showHideDialogAnimation(this.detail, true);
    //     this.lbMessageExplain.string = this.lbMessageExplain.string.replace(/#/g, `${gameConfig.INFINITY_POWER_VIDEO_COUNT}`);
    // }

    async OnPageOpen(prams?: IPagePramsBase){
        this.UpdateLookLabel();
        this.lbMessageExplain.string = this.lbMessageExplain.string.replace(/#/g, `${gameConfig.INFINITY_POWER_VIDEO_COUNT}`);
        super.OnPageOpen(prams);
    }

    OnNoLookBtn() {
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        // this.onClose();
        this.ClosePage();
    }

    OnLookBtn() {
        O1HD.getManagers().soundMgr.playSound('anNiu').then();
        if (InfinityPower.lookedTimes < gameConfig.INFINITY_POWER_VIDEO_COUNT) {
            utilsModel.loadAndShowVideoAdTrans(() => {
                    InfinityPower.lookedTimes++
                    this.UpdateLookLabel()
                    if (InfinityPower.lookedTimes == gameConfig.INFINITY_POWER_VIDEO_COUNT) {
                        //进入无限体力模式
                        O1HD.getServices().userSrv.setPower(999, true, true)
                        O1HD.getServices().localStorageSrv.setStorage(this.InfinityModel, 1)
                        O1HD.getModules().uiControlModule.showGetRewarded(REWARD_TYPE.POWER, 999, '获得体力');
                        // this.onClose();
                        this.ClosePage();
                    }
                }, () => {
                },
                null,
                '解锁无限体力'
            )
        }
    }

    // onClose() {
    //     modules().uiControlModule.showHideDialogAnimation(this.detail, false, () => {
    //         this.node.destroy();
    //     })
    // }

    UpdateLookLabel() {
        if (this.looktimeLabel) {
            this.looktimeLabel.string = `(${InfinityPower.lookedTimes.toString()}/${gameConfig.INFINITY_POWER_VIDEO_COUNT})`;
        }
    }

    // update (dt) {}
}
